import React, { useEffect } from "react";
import InspectionImg from "../images/scan/quick-inspection.png";
import BiddingImg from "../images/scan/fw-live-bidding.png";
import BuySellImg from "../images/scan/fw-buy-sell-cars.png";
import GooglePlay from "../images/google-play-badge.png";
import AppleStore from "../images/app-store.jpg";
import logo from "../images/fame-wheels-logo.png";

export default function ScanMe() {
  useEffect(() => {
    document.title = "Scan Me | FameWheels";
  }, []);
  useEffect(() => {
    document.body.classList.add("hide-scan");
    return () => document.body.classList.remove("hide-scan");
  }, []);
  return (
    <>
      <div className="container pt-3 pb-5 ">
        <div className="w-50 m-auto">
          <img src={logo} className="img-fluid   " alt="" srcset="" />
        </div>
        <div className="text-center">
          <h2 className=" section-titles pt-4 ">
            <span className="color-secondary">Scan. Click. Drive</span>
            <br /> Download Fame Wheels Now!
          </h2>
          <p className="fs-14 mb-4">
            The ultimate car buying and selling experience is just one scan
            away. Download the Fame Wheels app today and get the best deals at
            your fingertips!
          </p>
        </div>
        <div className="card_bg mx-2 mb-4 p-4 rounded-4 ">
          <h2 className="text-center section-titles mb-0 mb-md-4 ">
            <span className="color-secondary">Key</span> Benefits
          </h2>
          <div className="row m-auto ">
            <div className="col-lg-4 col-12 text-center my-3 ">
              <div>
                <img
                  src={InspectionImg}
                  className="img-fluid"
                  alt="inspection"
                />
                <h5 className="fs-6 fw-normal mt-3 mb-0">
                  Quick Car Inspections – Get your car evaluated in minutes
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-12 text-center my-3 ">
              <div>
                <img src={BiddingImg} className="img-fluid" alt="inspection" />
                <h5 className="fs-6 fw-normal mt-3 mb-0">
                  Live Bidding – Sell your car at the best price instantly
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-12 text-center my-3 ">
              <div>
                <img src={BuySellImg} className="img-fluid" alt="inspection" />
                <h5 className="fs-6 fw-normal mt-3 mb-0">
                  Buy & Sell with Ease – A seamless experience for car
                  enthusiasts
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-2">
          <h3
            style={{
              lineHeight: "1.8rem",
            }}
            className="color-secondary fs-4 text-center fw-700 "
          >
            Exclusive Ramazan Giveaways Download now and get a chance to win
            exciting prizes!
          </h3>
          <h3 className="color-black fs-4 text-center fw-700 mt-3 mb-4 ">
            Download Now
          </h3>
          <div className="d-flex justify-content-center gap-2 mb-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.famewheels"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={GooglePlay}
                alt="Google Play Store"
                className="img-fluid"
                style={{ height: 40, objectFit: "contain" }}
              />
            </a>
            <a
              href="https://apps.apple.com/pk/app/famewheels-car-live-bidding/id6475592948"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={AppleStore}
                alt="Apple App Store"
                className="img-fluid"
                style={{ height: 40, objectFit: "contain" }}
              />
            </a>
          </div>
        </div>
        <div className="mx-2 pb-5">
          <h2 className=" section-titles pt-4 ">
            How <span className="color-secondary">it works:</span>
          </h2>
          <ul className="ps-3">
            <li>
              <p className="fs-6">Scan the QR code on your phone</p>
            </li>
            <li>
              <p className="fs-6">Download the FameWheels Mobile app</p>
            </li>
            <li>
              <p className="fs-6">
                Start Buying, Selling, and Finding Cars Effortlessly
              </p>
            </li>
          </ul>
          <div className="text-center">
            <h2 className=" section-titles pt-4 ">
              <span className="color-secondary">
                Download Now & Enter Our Special
              </span>
              <br /> Giveaway!
            </h2>
          </div>
        </div>
      </div>
    </>
  );
}
